package com.parmartechnologies.core.feature.inventory.inventory.model

import com.parmartechnologies.core.extension.BaseDataClass
import com.parmartechnologies.core.feature.product.model.ProductPrice
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@Serializable
data class Inventory @OptIn(ExperimentalTime::class) constructor(
    @SerialName("inventory_id") var InventoryId: Long = Clock.System.now().epochSeconds,
    @SerialName("product_id") var ProductID: String = "",
    @SerialName("user_id") var UserID: String = "",
    @SerialName("business_id") var BusinessID: String = "",
    @SerialName("store_id") var storeId: String = "",
    @SerialName("category_id") var CategoryID: String = "",
    @SerialName("sub_category_id") var SubCategoryID: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
    @SerialName("name") var Name: String = "",
    @SerialName("description") var Description: String = "",
    @SerialName("model") var Model: String = "",
    @SerialName("bar_code") var Barcode: String = "",
    @SerialName("brand_id") var BrandID: String = "",
    @SerialName("uom_id") var UOMID: String = "",
    @SerialName("color_id") var ColorID: String = "",
    @SerialName("quantity") var Quantity: Long = 0L,
    @SerialName("size_id") var SizeID: String = "",
    @SerialName("discount_id") var DiscountID: String = "",
    @SerialName("coupon_id") var CouponID: String = "",
    @SerialName("tag_id") var TagID: String = "",
    @SerialName("MaxQuantity") var MaxQuantity: Long = 0,
    @SerialName("MinQuantity") var MinQuantity: Long = 0,
    @SerialName("StartRange") var StartRange: Long = 0,
    @SerialName("EndRange") var EndRange: Long = 0,
    @SerialName("SerialLength") var SerialLength: Long = 0,
    @SerialName("ShortCode") var ShortCode: String = "",
    @SerialName("product_price") var ProductPrice: ProductPrice? = ProductPrice(),
): BaseDataClass()